import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../appUtils/axiosConfig";

const initialState = {

    isLoading: false,
    error: null,
    products: [],
    isProductLoading: false,
    singleproducts: null,
    issingleLoading: false,
    activeproducts: [],
    isActiveLoading: false,
    relatedproducts: [],
    isRelatedLoading: false,
    isSearchLoading: false,
    searchproducts: []


}

export const getProducts = createAsyncThunk(
    'get_product_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getProductsStart());
            const response = await axios.get(`/products/get_product.php?showin_home`)
            if (response?.data?.status == 'success') {

                dispatch(getProductsSuccess(response?.data?.data))
            }


        } catch (error) {
            dispatch(getProductsFailure(error.response.data.message))
        }
    }
)
export const addProduct = createAsyncThunk(
    "addproducts",
    async (data, { dispatch, rejectWithValue }) => {
        try {
            dispatch(addProductStart());
            const response = await axios.post(`/products/add_product.php`, data);
            dispatch(addProductSuccess(response.data?.user));
            if (response?.data?.status == 'success') {
                dispatch(getProducts())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(addProductFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const deleteProduct = createAsyncThunk('deleteproduct', async (id, { dispatch, rejectWithValue }) => {
    try {
        dispatch(updateProductStart());
        const response = await axios.delete(`/products/delete_product.php?id=${id}`);
        if (response?.data?.status == 'success') {
            dispatch(getProducts())
            // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
        }
        return response.data
    } catch (error) {
        // SHOW_ERROR_NOTIFICATION(error.response.data.message);
        return rejectWithValue(error.response.data.message);
    }
})
export const updateProduct = createAsyncThunk(
    "addproducts",
    async ({ data }, { dispatch, rejectWithValue }) => {

        try {
            dispatch(updateProductStart());
            const response = await axios.post(`/products/update_product.php`, data);
            dispatch(updateProductSuccess(response.data?.user));
            if (response?.data?.status == 'success') {
                dispatch(getProducts())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(updateProductFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);

export const getCategories = createAsyncThunk(
    'get_categories',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            const response = await axios.get(`/get_categories.php`)
            return response.data
        } catch (error) {
        }
    }
)

export const getActiveProducts = createAsyncThunk(
    'get_active_product_page',
    async ({ division, species, category, domains, showin_home, page = 1, limit = 12, search = "" }, { dispatch, rejectWithValue }) => {
        const filters = { division, targetspecies: species, category, domains, showin_home, page, limit, search };
        // Build query string dynamically (skip null/empty/0)
        const queryParams = new URLSearchParams();

        Object.entries(filters).forEach(([key, value]) => {
            if (value !== null && value !== "" && value !== 0) {
                queryParams.append(key, value);
            }
        });

        try {
            dispatch(getActiveProductsStart());
            const response = await axios.get(`/products/get_active_products.php?${queryParams.toString()}`)
            if (response?.data?.status == 'success') {

                dispatch(getActiveProductsSuccess(response?.data?.data))
            }

            return response.data
        } catch (error) {
            dispatch(getActiveProductsFailure(error.response.data.message))
        }
    }
)
export const getRelatedActiveProducts = createAsyncThunk(
    'get_related_active_product_page',
    async ({ category, excludeId }, { dispatch, rejectWithValue }) => {
        const filters = { category, excludeId };

        // Build query string dynamically (skip null/empty/0)
        const queryParams = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
            if (value !== null && value !== "" && value !== 0) {
                queryParams.append(key, value);
            }
        });

        try {
            dispatch(getRelatedProductsStart());
            const response = await axios.get(`/products/get_related_products.php?${queryParams.toString()}`)
            if (response?.data?.status == 'success') {

                dispatch(getRelatedProductsSuccess(response?.data?.data))
            }

            return response.data
        } catch (error) {
            dispatch(getRelatedProductsFailure(error.response.data.message))
        }
    }
)
export const getSingleProducts = createAsyncThunk(
    'get_product_page',
    async (slug, { dispatch, rejectWithValue }) => {
        try {
            dispatch(getSingleProductsStart());
            const response = await axios.get(`/products/get_singleproduct.php?slug=${slug}`)
            if (response?.data?.status == 'success') {

                dispatch(getSingleProductsSuccess(response?.data?.data))
            }
            return response.data

        } catch (error) {
            dispatch(getSingleProductsFailure(error.response.data.message))
        }
    }
)

export const getSearchProducts = createAsyncThunk(
    'products_search',
    async (searchText, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getSearchProductsStart());
            const response = await axios.get(`/products/product_search.php?q=${searchText}`)
            if (response?.data?.status == 'success') {

                dispatch(getSearchProductsSuccess(response?.data?.data))
            }
        } catch (error) {
            dispatch(getSearchProductsFailure(error.response.data.message))
        }
    }
)
const productsSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {
        getProductsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getProductsSuccess(state, action) {

            state.products = action.payload;
            state.isLoading = false;
        },
        getProductsFailure(state, action) {
            state.products = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        getActiveProductsStart(state) {
            state.isActiveLoading = true;
            state.error = null;
        },
        getActiveProductsSuccess(state, action) {

            state.activeproducts = action.payload;
            state.isActiveLoading = false;
        },
        getActiveProductsFailure(state, action) {
            state.activeproducts = null;
            state.isActiveLoading = false;
            state.error = action.payload;

        },
        getRelatedProductsStart(state) {
            state.isRelatedLoading = true;
            state.error = null;
        },
        getRelatedProductsSuccess(state, action) {

            state.relatedproducts = action.payload;
            state.isRelatedLoading = false;
        },
        getRelatedProductsFailure(state, action) {
            state.relatedproducts = null;
            state.isRelatedLoading = false;
            state.error = action.payload;

        },
        getSingleProductsStart(state) {
            state.issingleLoading = true;
            state.error = null;
        },
        getSingleProductsSuccess(state, action) {
            state.singleproducts = action.payload;
            state.issingleLoading = false;
        },
        getSingleProductsFailure(state, action) {
            state.singleproducts = null;
            state.issingleLoading = false;
            state.error = action.payload;

        },
        addProductStart(state) {
            state.isProductLoading = true;
            state.error = null;
        },
        addProductSuccess(state, action) {
            state.user = action.payload;
            state.isProductLoading = false;
        },
        addProductFailure(state, action) {
            state.error = action.payload;
            state.isProductLoading = false;
        },

        updateProductStart(state) {
            state.isProductLoading = true;
            state.error = null;
        },
        updateProductSuccess(state, action) {
            state.user = action.payload;
            state.isProductLoading = false;
        },
        updateProductFailure(state, action) {
            state.error = action.payload;
            state.isProductLoading = false;
        },
        getSearchProductsStart(state) {
            state.isSearchLoading = true;
            state.error = null;
        },
        getSearchProductsSuccess(state, action) {

            state.searchproducts = action.payload;
            state.isSearchLoading = false;
        },
        getSearchProductsFailure(state, action) {
            state.searchproducts = null;
            state.isSearchLoading = false;
            state.error = action.payload;

        },
    }
})

export const { getProductsSuccess, getProductsStart, getProductsFailure, getActiveProductsSuccess, getActiveProductsStart, getActiveProductsFailure, getRelatedProductsSuccess, getRelatedProductsStart, getRelatedProductsFailure, getSingleProductsSuccess, getSingleProductsStart, getSingleProductsFailure, addProductStart, addProductSuccess, addProductFailure, updateProductStart, updateProductSuccess, updateProductFailure, getSearchProductsSuccess, getSearchProductsStart, getSearchProductsFailure } = productsSlice.actions;

export default productsSlice.reducer;